export class IsoDateWithPrecision {
  isoDate: string;
  precision: string;
  dd_error_message: string;
}
